import { RouteConfig } from 'vue-router';

export class MeetingRoute {
  static MEETINGS: RouteConfig = {
    name: 'meetings',
    path: 'meetings'
  };
}
